import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="bg-[#002347] text-white text-xs md:text-base">
      <footer className="max-w-screen-xl mx-auto flex items-center justify-between flex-col md:flex-row gap-6 py-10 md:py-32 px-10 md:px-0">
        <section className="h-full space-y-8 md:space-y-24 w-96">
          <img
            src="/logo-white.png"
            alt="logo white"
            className="w-[40px] ml-10 md:ml-0 md:w-[80px]"
          />
          <p className="hidden sm:block">
            &copy; Copyright {new Date().getFullYear()} Sleengshort LTD 4A, Olaide Omotoro Street off CIS road, off Amore, lekki, Lagos
          </p>
          <div className="hidden md:flex">
            {socialLinks.map((item, i) => (
              <a
                key={i}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={item.icon} alt="social icons" />
              </a>
            ))}
          </div>
        </section>

        <section className="">
          <div className="flex flex-col-reverse md:flex-row md:gap-16 gap-6">
            <ul className="space-y-2 flex flex-col">
              <li className="text-[#0075FF] font-semibold text-xs md:text-base">
                Product
              </li>
              {[
                { name: "Bulk SMS" },
                { name: "USSD" },
                { name: "SMS Campaign" },
                { name: "Developer" },
              ].map((item, i) => (
                <Link
                  to={
                    item.name === "Bulk SMS"
                      ? "/bulk-sms"
                      : item.name === "USSD"
                      ? "/ussd"
                      : item.name === "SMS Campaign"
                      ? "/campaigns"
                      : "https://sleengshort.gitbook.io/sleengshort-sms-api-documentation/"
                  }
                  key={i}
                  className="text-xs md:text-base"
                  onClick={() => window.scrollTo(0, 0)} // Scroll to top on click
                >
                  {item.name}
                </Link>
              ))}
            </ul>

            <ul className="space-y-2 flex flex-col">
              <li className="text-[#0075FF] font-semibold text-xs md:text-base">
                Company
              </li>
              {[
                { name: "About Us" },
                { name: "Support" },
                { name: "Api Documentation" },
                { name: "Privacy Policy" },
              ].map((item, i) => (
                <Link
                  to={
                    item.name === "About Us"
                      ? "/about"
                      : item.name === "Support"
                      ? "/faq"
                      : item.name === "Privacy Policy"
                      ? "/privacy-policy"
                      : "https://sleengshort.gitbook.io/sleengshort-sms-api-documentation/"
                  }
                  key={i}
                  className="text-xs md:text-base"
                  onClick={() => window.scrollTo(0, 0)} // Scroll to top on click
                >
                  {item.name}
                </Link>
              ))}
            </ul>

            <div>
              <ul className="space-y-2">
                <li className="text-[#0075FF] font-semibold text-xs md:text-base">
                  Call Us
                </li>
                {[
                  { image: "/nigeria.png", name: "+2348114159025" },
                  { image: "/great-britain.png", name: "+447944554720" },
                ].map((item, i) => (
                  <li
                    key={i}
                    className="text-xs md:text-base flex gap-2 items-center"
                  >
                    <img src={item.image} alt="flag icon" className="w-7 h-7" />
                    <span>{item.name}</span>
                  </li>
                ))}
              </ul>

              <ul className="mt-6">
                <li className="text-[#0075FF] font-semibold text-xs md:text-base">
                  Email
                </li>
                <li>Support@sleengshort.com</li>
              </ul>
            </div>
          </div>

          <div className="mt-20 flex flex-col md:flex-row md:items-center gap-10">
            <div className="md:w-56">
              <img src="/nigeria.png" alt="nigeria flag" />
              <p>4A, Olaide Omotoro Street off CIS road, off Amore, lekki</p>
            </div>
            <div className="md:w-56">
              <img src="/great-britain.png" alt="nigeria flag" />
              <p>71-75 Shelton street covent garden London</p>
            </div>
          </div>
        </section>

        <p className="md:hidden block">
          &copy; Copyright {new Date().getFullYear()} Sleengshort LTD 4A, Olaide Omotoro Street off CIS road, off Amore, lekki
        </p>
        <div className="md:hidden flex w-full">
          {socialLinks.map((item, i) => (
            <a
              key={i}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={item.icon} alt="social icons" />
            </a>
          ))}
        </div>
      </footer>
    </div>
  );
}

export default Footer;

export const socialLinks = [
  {
    id: 1,
    icon: "/instagram.png",
    url: "https://instagram.com/sleengshort.ng?igshid=YmMyMTA2M2Y=",
  },
  {
    id: 2,
    icon: "/linkedin.png",
    url: "https://www.linkedin.com/company/sleengshort-limited/",
  },
  {
    id: 3,
    icon: "/x.png",
    url: "https://twitter.com/sleengshort_ng?t=lD1uc4f-eAN5qMFobLc99Q&s=09",
  },
];

export const phones = [{ id: 1, call: "+447576142906" }];
